import {
    CREATE_SURVEY_SUCCESS,
    UPDATE_SURVEY_SUCCESS,
    DELETE_SURVEY_SUCCESS,
    FETCH_SURVEYS_SUCCESS,
    UPDATE_SURVEY_STATUS_SUCCESS,
    DUPLICATE_SURVEY_SUCCESS
} from "../constants/surveyConstants";

const initialState = {
    surveys: [],
};

const surveyReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SURVEYS_SUCCESS:
            return {
                ...state,
                surveys: action.payload,
            };

        case CREATE_SURVEY_SUCCESS:
            return {
                ...state,
                surveys: [action.payload, ...state.surveys],
            };

        case UPDATE_SURVEY_SUCCESS:
        case UPDATE_SURVEY_STATUS_SUCCESS:
            return {
                ...state,
                surveys: state.surveys.map((survey) =>
                    survey._id === action.payload._id ? action.payload : survey
                ),
            };

        case DELETE_SURVEY_SUCCESS:
            return {
                ...state,
                surveys: state.surveys.filter((survey) => survey._id !== action.payload),
            };

        case DUPLICATE_SURVEY_SUCCESS:
            return {
                ...state,
                surveys: [action.payload, ...state.surveys],
            };

        default:
            return state;
    }
};

export default surveyReducer;

